import { ProDescriptions } from '@ant-design/pro-components';
import { Space } from 'antd';
import PropTypes from 'prop-types';

const splitLinks = (value) =>
  String(value || '')
    .split(',')
    .map((link) => link.trim())
    .filter(Boolean);

export const renderHotPotSourceLink = (url) =>
  url ? (
    <a href={url} target="_blank" rel="noreferrer">
      链接
    </a>
  ) : (
    '-'
  );

export const renderHotPotRelatedLinks = (value, record) => {
  const links = Array.from(new Set(splitLinks(value).filter((link) => link !== record?.url)));
  if (links.length === 0) {
    return '-';
  }
  return (
    <Space wrap>
      {links.map((link, index) => (
        <a key={link} href={link} target="_blank" rel="noreferrer">
          {`链接${index + 1}`}
        </a>
      ))}
    </Space>
  );
};

const HotPotPreview = ({ record }) => (
  <ProDescriptions
    column={1}
    dataSource={record || {}}
    columns={[
      { title: '热点标题', dataIndex: 'title' },
      { title: '热度指数', dataIndex: 'hot' },
      { title: '源头链接', dataIndex: 'url', render: renderHotPotSourceLink },
      { title: '核心关键词', dataIndex: 'keyword' },
      { title: '描述', dataIndex: 'description' },
      { title: 'IP 契合度', dataIndex: 'relevance' },
      { title: '采集状态', dataIndex: 'status' },
      { title: '热点平台', dataIndex: 'platforms' },
      { title: '相关链接', dataIndex: 'mergedUrls', render: renderHotPotRelatedLinks },
      { title: '创建时间', dataIndex: 'createdAt', valueType: 'dateTime' },
    ]}
  />
);

HotPotPreview.propTypes = {
  record: PropTypes.shape({}),
};

HotPotPreview.defaultProps = {
  record: undefined,
};

export default HotPotPreview;
